import { render, staticRenderFns } from "./MADDForm.vue?vue&type=template&id=8ae5ee50"
import script from "./MADDForm.vue?vue&type=script&lang=js"
export * from "./MADDForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ae5ee50')) {
      api.createRecord('8ae5ee50', component.options)
    } else {
      api.reload('8ae5ee50', component.options)
    }
    module.hot.accept("./MADDForm.vue?vue&type=template&id=8ae5ee50", function () {
      api.rerender('8ae5ee50', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/MADD/MADDForm.vue"
export default component.exports